"use strict";

exports.__esModule = true;
exports.textRenderer = exports.RENDERER_TYPE = void 0;
var _textRenderer = require("./textRenderer");
exports.RENDERER_TYPE = _textRenderer.RENDERER_TYPE;
exports.textRenderer = _textRenderer.textRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/textRenderer/index.js
// module id = 167
// module chunks = 0